import { useState } from "react"
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Typography,
  Stack,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material"
import CaptureVideoImage from "../hooks/Utils/CaptureVideoImage"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"

const statusOptions = ["New", "Used", "Refurbished"]

const AddItemForm = ({ onSubmit, onCancel }) => {
  const [form, setForm] = useState({
    title: "",
    description: "",
    price: "",
    status: "New",
  })
  const [image, setImage] = useState(null)
  const t = useTranslationSharie()

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // Basic validation
    if (!form.title || !form.price || !image) {
      alert("Please fill in at least Title, Price, and Image")
      return
    }
    if (onSubmit) onSubmit({ ...form, image: image })
  }

  return (
    <T>
      <Box
        component='form'
        onSubmit={handleSubmit}
        sx={{
          p: 3,
          bgcolor: "text.primary",
          borderRadius: 3,
          boxShadow: 3,
          minWidth: 320,
          maxWidth: 500,
          mx: "auto",
        }}
      >
        <Typography variant='h6' mb={2} color='primary'>
          Add New Item
        </Typography>

        <Stack spacing={2}>
          <TextField
            label={t("Title")}
            name='title'
            value={form.title}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            label={t("Description")}
            name='description'
            value={form.description}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
          />
          <div style={{ display: "flex", flexDirection: "row" }}>
            <TextField
              label={t("Price")}
              name='price'
              type='number'
              value={form.price}
              onChange={handleChange}
              fullWidth
              required
            />
            <FormControl fullWidth required>
              <InputLabel id='price-method-label'>{t("Payment Method")}</InputLabel>
              <Select
                labelId='price-method-label'
                id='price-method'
                name='payment'
                value={form.payment}
                label={t("Payment Method")}
                onChange={handleChange}
              >
                <MenuItem value='ILS'>ILS</MenuItem>
                <MenuItem value='Credit'>Credit</MenuItem>
                <MenuItem value='Give Away'>Give Away</MenuItem>
              </Select>
            </FormControl>
          </div>
          <CaptureVideoImage image={image} setImage={setImage} />

          <TextField
            label={t("Status")}
            name='status'
            value={form.status}
            onChange={handleChange}
            fullWidth
            select
          >
            {statusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>

          <Stack direction='row' spacing={2} justifyContent='space-between'>
            <Button variant='outlined' color='secondary' onClick={onCancel}>
              Cancel
            </Button>

            <Button variant='contained' type='submit' color='secondary'>
              Add Item
            </Button>
          </Stack>
        </Stack>
      </Box>
    </T>
  )
}

export default AddItemForm
